import Vue from 'vue'
import Vuex from 'vuex'
import Account from './account'
import SnackBar from './snackbar'
import Interception from './interception'

Vue.use(Vuex)

export const store =  new Vuex.Store({
  // application level state
  state: {
    globalError: null,
  },

  // state cannot be change directly by using store.state,
  // it needed to commit with mutation
  mutations: {
    globalError(state, payload) {
      state.globalError = payload
    }
  },

  // all page level must be module based
  modules: {
    account: Account,
    snackbar: SnackBar,
    interception: Interception
  }
})
